{
  "imprint-page": {
    "meta": {
      "title": "Beauty Booking: Impressum",
      "description": "Impressum"
    },
    "text": {
      "title": "Impressum",
      "address-and-contact-data": "ADRESSE & KONTAKTDATEN GEM. § 5 TMG",
      "address": "Adresse",
      "commercial-register": "Handelsregister",
      "contact": "Kontakt",
      "email": "E-Mail",
      "legal-representatives": "Gesetzliche Vertretungsberechtigte",
      "liability": "HAFTUNG",
      "liability-text-1": "Wir sind für die Inhalte unserer Internetseiten nach den Maßgaben der allgemeinen Gesetze, insbesondere nach § 7 Abs. 1 des Telemediengesetzes, verantwortlich. Alle Inhalte werden mit der gebotenen Sorgfalt und nach bestem Wissen erstellt. Soweit wir auf unseren Internetseiten mittels Hyperlink auf Internetseiten Dritter verweisen, können wir keine Gewähr für die fortwährende Aktualität, Richtigkeit und Vollständigkeit der verlinkten Inhalte übernehmen, da diese Inhalte außerhalb unseres Verantwortungsbereichs liegen und wir auf die zukünftige Gestaltung keinen Einfluss haben. Sollten aus Ihrer Sicht Inhalte gegen geltendes Recht verstoßen oder unangemessen sein, teilen Sie uns dies bitte mit.",
      "liability-text-2": "Die rechtlichen Hinweise auf dieser Seite sowie alle Fragen und Streitigkeiten im Zusammenhang mit der Gestaltung dieser Internetseite unterliegen dem Recht der Bundesrepublik Deutschland.",
      "telephone": "Telefon",
      "vat-id": "Ust-ID"
    }
  }
}
